import { createRouter, createWebHistory } from "vue-router";

// 定义路由
// 每个路由应该映射一个组件。
const routes = [
  {
    path: "/",
    redirect: "/wind",
  },

  {
    path: "/wind",
    name: "风电场",
    component: () =>
      import(/* webpackChunkName: "src" */ "@/views/wind/index-page.vue"),
  },
  {
    path: "/wind-mapbox",
    name: "风电场 Mapbox",
    component: () =>
      import(/* webpackChunkName: "wind-mapbox" */ "@/views/wind-mapbox/index-page.vue"),
  },
  {
    path: "/turbine/:id",
    name: "单机数字孪生",
    component: () =>
      import(/* webpackChunkName: "turbine" */ "@/views/turbine/index-page.vue"),
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes: routes,
});

export default router;
